import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=db1874d2&scoped=true"
import script from "./BasicInfo.vue?vue&type=script&lang=ts"
export * from "./BasicInfo.vue?vue&type=script&lang=ts"
import style0 from "../style.scss?vue&type=style&index=0&id=db1874d2&prod&lang=scss&scoped=true&external"
import style1 from "./BasicInfo.vue?vue&type=style&index=1&id=db1874d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1874d2",
  null
  
)

export default component.exports